<template>
  <b-dropdown
    right
    variant="link"
    class="publisher-language-selector"
    toggle-class="text-body text-nowrap"
    :aria-label="$t('language.choose')"
  >
    <template #button-content>
      <feather-icon
        icon="GlobeIcon"
        class="mr-50"
      />
      <span :lang="currentLanguage.code">{{ currentLanguage.name }}</span>
    </template>
    <b-dropdown-item
      v-for="language in languages"
      :key="language.code"
      :active="language.code === $i18n.locale"
      :lang="language.code"
      @click="selectLanguage(language.code)"
    >
      {{ language.name }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import { languages } from '@/libs/i18n/languages'
import { setLocale } from '@/libs/i18n'

export default {
  components: { BDropdown, BDropdownItem },
  data() {
    return { languages }
  },
  computed: {
    currentLanguage() {
      return languages.find(language => language.code === this.$i18n.locale) || languages[0]
    },
  },
  methods: {
    selectLanguage: setLocale,
  },
}
</script>

<style lang="scss">
.publisher-language-selector .dropdown-menu {
  max-height: 65vh;
  overflow-y: auto;
}
</style>
